/**
 * CompletionBarChart — 6-month task completion bar chart.
 *
 * Uses .stat-bars/.sb/.bar/.lab classes from screens.css (Profile section).
 * The tallest bar gets the .hi class (green-500 accent). Heights are
 * expressed as percentages of the container, matching designs/Profile.html.
 */

export type CompletionDatum = { month: string; count: number };
export type CompletionBarChartProps = {
  data: CompletionDatum[];
};

export function CompletionBarChart({ data }: CompletionBarChartProps) {
  const max = Math.max(1, ...data.map((d) => d.count));
  return (
    <div
      className="stat-bars"
      aria-label="Completions per month, last 6 months"
    >
      {data.map((d) => {
        const pct = Math.round((d.count / max) * 100);
        const isHi = d.count === max && d.count > 0;
        return (
          <div key={d.month} className="sb">
            <div
              className={`bar${isHi ? " hi" : ""}`}
              style={{ height: `${pct}%` }}
              title={`${d.month}: ${d.count}`}
            />
            <span className="lab">{d.month}</span>
          </div>
        );
      })}
    </div>
  );
}
